export function trackEvent(eventName, payload = {}) {
  if (!eventName) return;
  try {
    if (typeof window !== "undefined") {
      if (window?.analytics?.track) {
        window.analytics.track(eventName, payload);
      }
      if (Array.isArray(window?.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...payload });
      }
    }
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.warn("trackEvent failed", err);
    }
  }
}
